import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {
  Modal,
  Button,
  Image,
  Row,
  Col,
  Container,
  Form,
  CloseButton,
  ListGroup,
  Badge
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Noimage from '../../Images/Noimage.svg';
const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};
if (typeof document !== 'undefined') {
  const styleId = 'slide-right-cart-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.innerHTML = `
    
    .modal.fade .modal-dialog.slide-right {
      transform: translateX(100%);
      transition: transform 0.3s ease-out;
    }
    .modal.show .modal-dialog.slide-right {
      transform: translateX(0);
    }
    .modal.slide-right-modal .modal-dialog {
      position: fixed;
      right: 0;
      top: 0;
      margin: 0;
      height: 100%;
      max-width: 480px;
      width: 100%;
    }
    .modal.slide-right-modal .modal-content {
      height: 100%;
      border-radius: 0;
      border: none;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .cart-item-title {
      font-weight: 600;
      font-size: 0.9rem;
      margin-bottom: 0.2rem;
    }
    .cart-item-details {
      font-size: 0.85rem;
      color: #6c757d;
    }
    .hide-scrollbar::-webkit-scrollbar {
      display: none;
    }
    .hide-scrollbar {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
    @media (max-width: 767px) {
      .modal.slide-right-modal .modal-dialog {
        width: 100% !important;
        max-width: 100% !important;
      }
    }     
    `;
    document.head.appendChild(style);
  }
}

const QuickViewModal = ({ show, onHide }) => {
  const [agreeTerms, setAgreeTerms] = useState(false);
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [recommended, setRecommended] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false);
const [showCart, setShowCart] = useState(false);

  const getAuthToken = () => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) return "";
    try {
      const parsed = JSON.parse(userData);
      return parsed.token || "";
    } catch {
      return "";
    }
  };
  const isLoggedIn = !!getAuthToken();




const getPriceDetails = (product) => {
  const mrp = parseFloat(product.mrp || 0);
  const special = parseFloat(product.special_price || 0);
  const offer = parseFloat(product.offer_price || 0);

  let finalPrice = mrp;
  let strikePrice = null;

  if (offer > 0) {
    finalPrice = offer;

    // Strike based on discount_from
    if (product.offer?.discount_from === "srp") {
      strikePrice = special > 0 ? special : mrp;
    } else if (product.offer?.discount_from === "mrp") {
      strikePrice = mrp;
    }
  } else if (special > 0) {
    // Always use special price if exists
    finalPrice = special;
    strikePrice = mrp; // strike is always mrp
  } else {
    finalPrice = mrp;
    strikePrice = null;
  }

  return {
    finalPrice,
    strikePrice,
    discountPercent:
      strikePrice && strikePrice > finalPrice
        ? Math.round(((strikePrice - finalPrice) / strikePrice) * 100)
        : 0,
  };
};



  const fetchCart = async () => {
    const token = getAuthToken();

    if (!token) {
      console.warn("No auth token found, user may need to login.");
      setCartItems([]);
      return;
    }

    try {
      const res = await axios.get(
        "https://vantara.datacubeglobal.com/api/cart",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data.status === "success") {
        const mappedItems = res.data.data.map((item) => {
          // ✅ primary_image is an object, not an array
          const imagePath = item.product?.primary_image?.image_path;
          const imageUrl = imagePath
            ? `https://vantara.datacubeglobal.com/storage/${imagePath}`
            : "https://via.placeholder.com/70"; // fallback image
const { finalPrice, strikePrice, discountPercent } = getPriceDetails(item.product);
          return {
            id: item.cart_id,
            title: item.product?.product_name || "Unnamed Product",
            product_id: item.product.encrypted_product_id,
            variant: "",
              price: finalPrice, 
            // price: parseFloat(item.product?.special_price || 0),
            quantity: item.quantity,
            image: imageUrl,
              total: finalPrice * item.quantity,
          strikePrice,            // optional for showing in cart UI
          discountPercent, 
          };
        });


        setCartItems(mappedItems);
        // console.log(mappedItems,'jjjj');

      }
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  };
  useEffect(() => {
    if (!show) return;

    fetchCart();
  }, [show]);









  // useEffect(() => {
  //   if (!show) return;

  //   axios
  //     .get("https://vantara.datacubeglobal.com/api/random_products")
  //     .then((res) => {
  //       if (res.data.status === "success") {
  //         const mapped = res.data.data.map((p) => {
  //           let displayPrice = 0;

  //           switch (p.primary_price) {
  //             case "mrp":
  //               displayPrice = parseFloat(p.mrp);
  //               break;
  //             case "special_price":
  //               displayPrice = parseFloat(p.special_price);
  //               break;
  //             case "retail":
  //               displayPrice = parseFloat(p.retail);
  //               break;
  //             case "wholesale":
  //               displayPrice = parseFloat(p.wholesale);
  //               break;
  //             default:
  //               displayPrice = parseFloat(p.mrp);
  //           }

  //           return {
  //             id: p.product_id,
  //             title: p.product_name,
  //             price: displayPrice,
  //             img: `https:\/\/vantara.datacubeglobal.com\/storage/${p.primary_image}`,
  //             is_wishlisted: p.is_wishlisted || false,
  //           };
  //         });

  //         setRecommended(mapped);
  //       }
  //     })
  //     .catch((err) => console.error("Error fetching random products:", err));
  // }, [show]);

useEffect(() => {
  if (!show) return;

  axios
    .get("https://vantara.datacubeglobal.com/api/random_products")
    .then((res) => {
      if (res.data.status === "success") {
        const mapped = res.data.data.map((p) => {
          let displayPrice = 0;
          let cutPrice = 0;

          // --------------------------
          // OFFER CHECKING LOGIC
          // --------------------------
          if (p.offer && p.offer_price) {
      
            displayPrice = parseFloat(p.offer_price);

    
            if (p.offer.discount_from === "mrp") {
              cutPrice = parseFloat(p.mrp);
            } else if (p.offer.discount_from === "srp") {
              cutPrice = parseFloat(p.special_price);
            } else {
              cutPrice = parseFloat(p.mrp);
            }
          } else {
        
            switch (p.primary_price) {
              case "mrp":
                displayPrice = parseFloat(p.mrp);
                break;
              case "special_price":
                displayPrice = parseFloat(p.special_price);
                break;
              case "retail":
                displayPrice = parseFloat(p.retail);
                break;
              case "wholesale":
                displayPrice = parseFloat(p.wholesale);
                break;
              default:
                displayPrice = parseFloat(p.mrp);
            }

            cutPrice = parseFloat(p.mrp);
          }

          // Calculate offer %
          const discountPercent =
            cutPrice > displayPrice
              ? Math.round(((cutPrice - displayPrice) / cutPrice) * 100)
              : 0;

          return {
            id: p.product_id,
            product_id: p.product_id,
            title: p.product_name,
            name: p.product_name,
            price: displayPrice,
            originalPrice: cutPrice,
            isSale: displayPrice < cutPrice,
            discountPercent,

            stock: p.stock,
            is_wishlisted: p.is_wishlisted || false,

            hasOffer: p.offer_price !== null,
            offerPrice: p.offer_price,
            offer: p.offer,

            is_featured: p.is_featured || false,

            img: p.primary_image
              ? `https://vantara.datacubeglobal.com/storage/${p.primary_image}`
              : "",
            image: p.primary_image
              ? `https://vantara.datacubeglobal.com/storage/${p.primary_image}`
              : "",

            category: p.category || "Others",
          };
        });

        setRecommended(mapped);
      }
    })
    .catch((err) => console.error("Error fetching random products:", err));
}, [show]);



  const removeItem = async (product_id) => {
    const token = getAuthToken();
    if (!token) return;



    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart/remove-item",
        { product_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("📩 API Response:", res.data);

      if (res.data.status === "success") {
        fetchCart();
      }
    } catch (err) {
      console.error("Error removing item:", err);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);
  // Add to Cart API Integration
  const handleAddToCart = async (product) => {
    const token = getAuthToken();

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Login Required",
        text: "Please login to add items to your cart.",
      });
      return;
    }

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart",
        {
          product_id: product?.id || product?.product_id,
          quantity: 1,
          options: "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Added to Cart!",
          text: `${product.title} has been added to your cart.`,
          timer: 1200,
          showConfirmButton: false,
        });
        fetchCart(); // 🔄 Refresh cart list
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res.data.message || "Failed to add product to cart.",
        });
      }
    } catch (err) {
      console.error("Add to cart error:", err);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Unable to add item to cart. Please try again later.",
      });
    }
  };


  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="slide-right-modal fade"
      dialogClassName="slide-right"
      backdrop={true}
      keyboard={true}
    >
      <Modal.Header className="border-bottom px-4 py-3 align-items-center">
        <Modal.Title className="h5 mb-0 fw-bold">Shopping Cart</Modal.Title>
        <CloseButton onClick={onHide} />
      </Modal.Header>

      <Modal.Body className="p-0 d-flex flex-column" style={{ height: "calc(100vh - 65px)", overflow: "hidden" }}>
        {/* Main Content Scroll Area */}
        <div className="flex-grow-1 overflow-auto px-4 py-3 hide-scrollbar">
          {/* Cart Items List */}
          <div className="mb-4">
            {cartItems.length === 0 ? (
              <div className="text-center py-5 text-muted">
                <i className="bi bi-cart-x fs-1 d-block mb-2 text-secondary opacity-50"></i>
                Your cart is empty
              </div>
            ) : (
              <ListGroup variant="flush">
                {cartItems.map((item) => (
                  <ListGroup.Item key={item.id} className="px-0 py-3 border-bottom">
                    <Row className="align-items-center g-2">
                      <Col xs={3} sm={2}>
                        <Image
                          src={item.image}
                          alt={item.title}
                          fluid
                          rounded
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = Noimage;
                          }}
                          style={{ width: "100%", height: "65px", objectFit: "cover" }}
                        />
                      </Col>
                      <Col xs={7} sm={8}>
                        <div className="cart-item-title text-truncate">{item.title}</div>
                        {item.variant && <div className="cart-item-details mb-1">{item.variant}</div>}
                        <div className="small text-muted">
                          {item.quantity} × <span className="fw-semibold text-dark">₹{item.price.toFixed(2)}</span>
                        </div>
                      </Col>
                      <Col xs={2} sm={2} className="text-end">
                        <CloseButton style={{ fontSize: "0.75rem" }} onClick={() => removeItem(item.product_id)} />
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </div>

          {/* You May Also Like Section */}
          {recommended.length > 0 && (
            <div className="pt-2 border-top">
              <h6 className="fw-bold mb-3">You May Also Like</h6>
              <div className="d-flex gap-3 overflow-x-auto pb-2 hide-scrollbar">
                {recommended.map((p) => (
                  <div
                    key={p.id}
                    className="flex-shrink-0 text-center p-2 rounded shadow-sm border"
                    style={{ width: "140px", background: "#fff" }}
                  >
                    <Image
                      src={p.img}
                      fluid
                      rounded
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = Noimage;
                      }}
                      onClick={() => {
                        onHide();
                        navigate(`/productDetails/${p.id}`);
                      }}
                      style={{ height: "90px", width: "100%", objectFit: "cover", cursor: "pointer" }}
                    />
                    <div className="small text-truncate mt-2 fw-semibold text-dark">{p.title}</div>
                    <div className="small fw-bold mb-2" style={{ color: "#7c0046" }}>
                      ₹{p.price}
                    </div>
                    <Button
                      size="sm"
                      className="w-100 fw-semibold py-1"
                      style={{ backgroundColor: "#124F14", borderColor: "#124F14", borderRadius: "15px", fontSize: "11px" }}
                      onClick={() => handleAddToCart(p)}
                    >
                      <i className="bi bi-cart-plus me-1"></i> Add
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Sticky Bottom Action & Subtotal Area */}
        <div className="px-4 py-3 border-top bg-white flex-shrink-0 shadow-lg">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="fw-bold text-dark fs-5">Subtotal</span>
            <span className="fw-bold text-dark fs-5">₹{subtotal.toFixed(2)}</span>
          </div>
          <div className="d-flex justify-content-between mb-3 text-muted small">
            <span>Shipping</span>
            <span className="text-success fw-semibold">Free</span>
          </div>

          <div className="d-flex gap-2">
            <Button
              variant="outline"
              size="md"
              style={{ backgroundColor: "#7c0046", color: "#fff", borderColor: "#7c0046" }}
              className="flex-grow-1 fw-semibold rounded-pill"
              onClick={() => {
                onHide();
                if (!isLoggedIn) {
                  navigate("/login");
                  return;
                }
                navigate("/checkout");
              }}
            >
              View Cart
            </Button>
            <Button
              variant="outline"
              size="md"
              style={{ backgroundColor: "#124f14", color: "#fff", borderColor: "#124f14" }}
              className="flex-grow-1 fw-semibold rounded-pill"
              onClick={async () => {
                if (!isLoggedIn) {
                  onHide();
                  navigate("/login");
                  return;
                }
                const token = getAuthToken();
                const sessionId = localStorage.getItem("session_id");
                if (token && sessionId) {
                  try {
                    const cartIds = cartItems.map((item) => item.id);
                    await axios.post(
                      "https://vantara.datacubeglobal.com/api/checkout-click",
                      { session_id: sessionId, cart_ids: cartIds },
                      { headers: { Authorization: `Bearer ${token}` } }
                    );
                  } catch (error) {
                    console.error("Error during checkout-click API call:", error);
                  }
                }
                onHide();
                navigate("/proceedcheckout");
              }}
            >
              Check Out
            </Button>
          </div>

          <div className="text-center mt-2">
            <Button
              variant="link"
              size="sm"
              className="text-decoration-none text-muted fw-semibold"
              onClick={onHide}
            >
              OR CONTINUE SHOPPING
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default QuickViewModal;

